module.exports = __webpack_public_path__ + "static/media/infrastructure1.5995d668.jpeg";